<div [formGroup]="performancePeriod" class="row">
	<mat-form-field appearance="fill" class="col">
		<mat-label>{{label.length > 0 ? label : yearType === 'SchoolYear' ? 'School Year' : 'Performance Period'}}
		</mat-label>
		<mat-select formControlName="performanceSelect" [required]="required">
			<mat-option *ngFor="let year of years" [value]="year">
				{{year}}
			</mat-option>
		</mat-select>
	</mat-form-field>
</div>